var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f-listbox',{staticClass:"walletlistbox",attrs:{"data":_vm.data},on:{"component-change":_vm.onListboxItemSelected},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"flex juc-space-between"},[_c('span',[_vm._v(_vm._s(item.label))]),_c('app-iconset',{attrs:{"icon":item.value.icon,"original":""}})],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }